import NotFound from '@/views/exception/404.vue';
import ProLayout from '@/layout/light/Default.vue';
import RouteView from '@/layout/light/RouteView.js';

export default {
    NotFound,
    ProLayout,
    RouteView
};
